<p [innerHtml]="'popins.inspiration.line1' | translate"></p>
<p class="my-4">{{ 'popins.inspiration.line2' | translate }}</p>
<p>{{ 'popins.inspiration.line3' | translate }}</p>

<div class="text-center mt-3">
  <ng-casto-btn class="blue" (click)="modal.close()" [label]="'popins.inspiration.confirm' | translate"></ng-casto-btn>
</div>
